import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

export default definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eff7ff',
      100: '#dbeafe',
      200: '#c0defd',
      300: '#94cbfc',
      400: '#62adf8',
      500: '#4893f4',
      600: '#286fe8',
      700: '#2059d5',
      800: '#2049ad',
      900: '#204188',
      950: '#182853'
    }
  }
})
